import * as R from 'ramda';

export type Errors<T> = { [K in keyof T]?: string }

export interface PossibleError { error?: string }

export function noErrors<T>(errors: Errors<T>): boolean {
  return R.isEmpty(errors);
}
